import _ from '../../core/utils'
import API from '../api'
import HINT from '../hint' 
import MODAL from '../modal'
import SUBMIT from '../submit'
import API_USER_SIGNIN_CONFIG from './config'

class ApiUserSignin {
    constructor() {
        this.DOM = {
            form: API_USER_SIGNIN_CONFIG.form
        }

        this.endpoint = API_USER_SIGNIN_CONFIG.endpoint

        this.init()
    }

    init() {
        console.log( this )
        this.DOM.form ? this._listeners() : null
    }

    _listeners() {
        this.DOM.form.addEventListener( 'submit', this._submit.bind( this ) ) 
    }

    _submit() {
        event.preventDefault()
        let form = event.target

        SUBMIT._startLoading( form )
        API.post( this.endpoint, 
            new FormData( form )
        )
        .then( ( response ) => {
            console.log( response )
            
            if ( response.data.success ) {
                HINT._show( response.data.message, HINT.status.success )
                setTimeout( () => {
                    window.location.replace( response.data.location )
                }, 2000 )
            } else {
                HINT._show( response.data.message, HINT.status.error )
            }
            
        })
        .catch( ( error ) => {

        })
        .then( () => {
            SUBMIT._endLoading( form )
            HINT._hide()
        })
    }
} 

const API_USER_SIGNIN = new ApiUserSignin()
export default API_USER_SIGNIN